import { useEffect } from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { useBuildRumContext } from 'src/common/telemetry/DataDog/useBuildRumContext';
import { configureRumUser, setRumGlobalContext } from './datadogRumApi';

export const useInitializeDatadogRum = (): void => {
  const { user } = useAuth();
  const rumContext = useBuildRumContext();
  const { corpId, corpName, corpUserRole, corpType } = rumContext;

  const userId = user?.ud_id;

  useEffect(() => {
    if (userId) {
      configureRumUser({ id: userId });
    }
  }, [userId]);

  useEffect(() => {
    setRumGlobalContext({ corpId, corpName, corpUserRole, corpType });
  }, [corpId, corpName, corpUserRole, corpType]);
};
